import { create } from 'zustand'

interface FreespinsStore {
    currentFreespin: number
    totalFreespins: number
    isFreespinsEnding: boolean
    isShowingFreespinsSplash: boolean
    isFreespinsActive: boolean
    updateCurrentFreespin: (newFreespin: number) => void
    updateTotalFreespins: (newTotalFreespins: number) => void
    setIsShowingFreespinsSplash: (isShowing: boolean) => void
    setIsFreespinsActive: (isActive: boolean) => void
}

export const useFreespinsStore = create<FreespinsStore>((set) => ({
    currentFreespin: 0,
    totalFreespins: 0,
    isFreespinsEnding: false,
    isShowingFreespinsSplash: false,
    isFreespinsActive: false,
    updateCurrentFreespin: (newFreespin) =>
        set((state) => ({
            currentFreespin: newFreespin,
            isFreespinsEnding: state.totalFreespins ? newFreespin === state.totalFreespins : false,
        })),
    updateTotalFreespins: (newTotalFreespins) =>
        set((state) => ({
            totalFreespins: newTotalFreespins,
            isFreespinsEnding: newTotalFreespins ? state.currentFreespin === newTotalFreespins : false,
        })),
    setIsShowingFreespinsSplash: (isShowing) => set({ isShowingFreespinsSplash: isShowing }),
    setIsFreespinsActive: (isActive: boolean) => set({ isFreespinsActive: isActive }),
}))
